import React from 'react';
import HistoryTable from './HistoryTable';

const ReceivedHistory = ({ userID, collectionName }) => {
  const columns = [
    { key: 'date', label: 'Date & Time' },
    { key: 'amount', label: 'Amount' },
    { key: 'senderId', label: 'From (Sender ID)' },
  ];

  return (
    <HistoryTable
      userID={userID}
      collectionName={collectionName}
      historyType="receiveHistory"
      title="Received History"
      columns={columns}
      searchField="senderId"
      searchFieldLabel="Sender ID"
    />
  );
};

export default ReceivedHistory;